import { HttpService } from '@sphinx/leon-services'
import tokenService from './token.service'
import config from 'config/environment'

export const httpService = new HttpService(tokenService, {
  'X-Api-Key': config.sphinx_api_key,
})
